import Swiper from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';
import { BREAKPOINTS } from '../utils/constants';
import safeJsonParse from '../utils/safeJsonParse';

/**
 * Blog post related articles: a single set of cards that behaves as a
 * Swiper carousel at desktop width and stacks (no JS) at mobile width.
 * On viewport change, Swiper is initialised or destroyed accordingly.
 *
 * Swiper options come from the `data-swiper-config` attribute on
 * [data-related-swiper] so the Liquid section owns them; the JS only wires
 * the navigation DOM references.
 */
const initBlogPostRelated = (root = document) => {
  const containers = root.querySelectorAll('[data-blog-post-related]');
  if (!containers.length) return;

  const desktopMQ = window.matchMedia(`(min-width: ${BREAKPOINTS.DESKTOP}px)`);

  containers.forEach((container) => {
    if (container.dataset.bprBound === 'true') return;
    container.dataset.bprBound = 'true';

    const swiperEl = container.querySelector('[data-related-swiper]');
    if (!swiperEl) return;

    const userConfig = swiperEl.dataset.swiperConfig
      ? safeJsonParse(swiperEl.dataset.swiperConfig) || {}
      : {};
    const prevEl = container.querySelector('[data-swiper-prev]');
    const nextEl = container.querySelector('[data-swiper-next]');

    let instance = null;

    const enable = () => {
      if (instance) return;
      swiperEl.classList.add('swiper');
      const modules = [Navigation];
      if ('mousewheel' in userConfig) modules.push(Mousewheel);

      instance = new Swiper(swiperEl, {
        ...userConfig,
        navigation: userConfig.navigation && prevEl && nextEl
          ? {
            ...userConfig.navigation,
            prevEl,
            nextEl
          }
          : userConfig.navigation,
        modules
      });
    };

    const disable = () => {
      if (!instance) return;
      instance.destroy(true, true);
      instance = null;
      swiperEl.classList.remove('swiper');
    };

    const sync = () => {
      if (desktopMQ.matches) enable();
      else disable();
    };

    desktopMQ.addEventListener('change', sync);
    sync();
  });
};

export default initBlogPostRelated;
